import {
  GET_AUDIT_TRAIL_PENDING,
  GET_AUDIT_TRAIL_SUCCESS,
  GET_AUDIT_TRAIL_ERROR,
  EXPORT_AUDIT_TRAIL_PENDING,
  EXPORT_AUDIT_TRAIL_SUCCESS,
  EXPORT_AUDIT_TRAIL_ERROR,
  SET_AUDIT_TRAIL_DATA,
  SET_AUDIT_TRAIL_MODAL,
} from "../../actions/audit-trail";

const initialState = {
  pending: false,
  error: null,
  data: null,
  detailData: null,
  isOpenModal: false,
  modalType: "",
};

const auditTrail = (state = initialState, action) => {
  switch (action.type) {
    case GET_AUDIT_TRAIL_PENDING:
      return {
        ...state,
        pending: true,
      };
    case GET_AUDIT_TRAIL_SUCCESS:
      return {
        ...state,
        pending: false,
        data: action.data,
      };
    case GET_AUDIT_TRAIL_ERROR:
      return {
        ...state,
        pending: false,
        error: action.error,
      };
    case EXPORT_AUDIT_TRAIL_PENDING:
      return {
        ...state,
        pending: true,
      };
    case EXPORT_AUDIT_TRAIL_SUCCESS:
      return {
        ...state,
        pending: false,
        data: action.data,
      };
    case EXPORT_AUDIT_TRAIL_ERROR:
      return {
        ...state,
        pending: false,
        error: action.error,
      };
    case SET_AUDIT_TRAIL_DATA:
      return {
        ...state,
        detailData: action.data,
      };
    case SET_AUDIT_TRAIL_MODAL:
      return {
        ...state,
        isOpenModal: action.data.isOpen,
        modalType: action.data.modalType,
      };
    default:
      return state;
  }
};

export default auditTrail;
